import Vue from 'vue'
import Element from 'element-ui'
import './style-2f3337/index.css'
import './_style.less';

export function info(msg, duration = 2000, notify = false) {
  if (notify) {
    Element.Notification.info({
      title: '提示',
      message: msg,
      duration: duration
    })
    return;
  }
  Element.Message.info({
    message: msg,
    duration: duration
  })
}

export function success(msg, duration = 2000, notify = false) {
  if (notify) {
    Element.Notification.success({
      title: '提示',
      message: msg,
      duration: duration
    })
    return;
  }
  Element.Message.success({
    message: msg,
    duration: duration
  })
}

export function error(msg, duration = 2000, notify = false) {
  if (notify) {
    Element.Notification.error({
      title: '提示',
      message: msg,
      duration: duration
    })
    return;
  }
  Element.Message.error({
    message: msg,
    duration: duration
  })
}

export function alertMsg(msg, title = "提示") {
  Element.MessageBox.alert(msg, title, {
    showClose: false
  })
}

export function showValidate(data, title = '请按要求填写表单') {
  if (data) {
    let vList = [];
    Object.keys(data).forEach(key => {
      vList.push(...data[key].map((item) => {
        return item.message;
      }));
    });
    if (vList.length > 0) {
      Element.Notification.error({
        title: title,
        message: `${vList.map((item, i) => {
          return `[${i + 1}] ${item}`
        }).join("<br>")}`,
        dangerouslyUseHTMLString: true,
        duration: 1000
      })
    }
  }
}

Vue.prototype.info = info;
Vue.prototype.error = error;
Vue.prototype.success = success;
Vue.prototype.showValidate = showValidate;
Vue.use(Element);